import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const mobileCalendarGuard: CanActivateFn = () => {
  const router = inject(Router);

  // Gleiche Rollenquelle wie in deinem RoleGuard:
  const role = localStorage.getItem('role');

  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  const mobileRoles = ['Dolmetscher', 'Ausbildung', 'Teamleitung', 'Admin'];

  if (isMobile && role !== null && mobileRoles.includes(role)) {
    return router.createUrlTree(['/interpreter-calendar']);
  }

  return true;
};
